let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class BySearchService {
  constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }

  getProducts(text, userId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.searchProduct}${text}&userId=${userId}`,
        cache: false,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }

  updateFavoriteProducts(data){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setFavoriteProduct,
        cache : true,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data : this.$httpParamSerializerJQLike(data)
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }
}

BySearchService.$inject = inject;

export default BySearchService;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/fast-purchase/by-search/by-search.service.js
 **/